import * as Tone from "tone";
import { Timeline } from "../project/Timeline";
import { Composer } from "../Composer";
import { Instrument } from "../instruments/Instrument";
import { AudioMath } from "../../AudioMath";
import { Note } from "../notes/Note";

export class ComposerEngine
{
  ready:boolean = false;
  timeline:Timeline;

  get currentTime()
  {
    return AudioMath.secondsToBeats( Tone.Transport.seconds, this.timeline.bpm );
  }

  get currentSeconds()
  {
    return Tone.Transport.seconds;
  }

  get playing()
  {
    return Tone.Transport.state === "started";
  }
  
  initialize()
  {
    this.ready = true;
  }

  setTimeline( timeline:Timeline, position:number = 0 )
  {
    this.timeline = timeline;

    Tone.Transport.bpm.value = timeline.bpm;
    Tone.Transport.loopStart = AudioMath.beatsToSeconds( timeline.start, timeline.bpm );
    Tone.Transport.loopEnd   = AudioMath.beatsToSeconds( timeline.end, timeline.bpm );
    Tone.Transport.loop = true;
    Tone.Transport.start( 0 );
    Tone.Transport.seconds = AudioMath.beatsToSeconds( position, timeline.bpm );
    
    

    let composer = Composer.$;
    composer.ui.bpm.value = timeline.bpm;
    composer.ui.loopStart.value = timeline.start;
    composer.ui.loopEnd.value = timeline.end;    

    console.log( 
      "SETTING:", timeline, 
      Tone.Transport.bpm.value, 
      Tone.Transport.loopStart, 
      Tone.Transport.loopEnd 
      );
  }

  test()
  {
    const synth = new Tone.Synth().toDestination();

    //play a middle 'C' for the duration of an 8th note
    synth.triggerAttackRelease("C4", "8n");
  }
}